import jsPDF from "jspdf";
import logo from "../assets/logo.png";

const INVOICE_ISSUER = {
  name: "Lotus Rice Mill Pvt. Ltd.",
  address: "Old Agro Road, Saraiya, Chungi More, Tiraha, Etawah, UP 206001",
  gst: "09XXXXX0000X1ZX",
  email: "lotusrice.in@yahoo.com",
  phone: "-",
  pan: "-",
  bankName: "-",
  bankBranch: "-",
  bankAccount: "-",
  bankIfsc: "-",
  upiId: "-",
  signatoryName: "Lotus Rice Mill Pvt. Ltd.",
};

const fmtMoney = (n) => {
  const v = Number(n || 0);
  return `INR ${v.toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
};

const fmtDate = (v) => {
  if (!v) return "-";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("en-IN");
};

const isImageDataUrl = (value) => /^data:image\/(png|jpe?g|webp);base64,/i.test(String(value || "").trim());

const SMALL_NUMBERS = [
  "Zero",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
  "Ten",
  "Eleven",
  "Twelve",
  "Thirteen",
  "Fourteen",
  "Fifteen",
  "Sixteen",
  "Seventeen",
  "Eighteen",
  "Nineteen",
];

const TENS = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

const numberToWordsIndian = (value) => {
  const n = Math.floor(Number(value) || 0);
  if (n === 0) return "Zero";

  const twoDigits = (num) => {
    if (num < 20) return SMALL_NUMBERS[num];
    const tensWord = TENS[Math.floor(num / 10)];
    const unit = num % 10;
    return unit ? `${tensWord} ${SMALL_NUMBERS[unit]}` : tensWord;
  };

  const threeDigits = (num) => {
    const hundred = Math.floor(num / 100);
    const rest = num % 100;
    if (!hundred) return twoDigits(rest);
    if (!rest) return `${SMALL_NUMBERS[hundred]} Hundred`;
    return `${SMALL_NUMBERS[hundred]} Hundred ${twoDigits(rest)}`;
  };

  const parts = [];
  const crore = Math.floor(n / 10000000);
  const lakh = Math.floor((n % 10000000) / 100000);
  const thousand = Math.floor((n % 100000) / 1000);
  const remainder = n % 1000;

  if (crore) parts.push(`${numberToWordsIndian(crore)} Crore`);
  if (lakh) parts.push(`${numberToWordsIndian(lakh)} Lakh`);
  if (thousand) parts.push(`${numberToWordsIndian(thousand)} Thousand`);
  if (remainder) parts.push(threeDigits(remainder));

  return parts.join(" ").trim();
};

const amountToWordsInr = (value) => {
  const amount = Number(value || 0);
  const safeAmount = Number.isFinite(amount) ? Math.max(0, amount) : 0;
  const rupees = Math.floor(safeAmount);
  const paise = Math.round((safeAmount - rupees) * 100);
  const rupeesWords = numberToWordsIndian(rupees);
  if (!paise) return `INR ${rupeesWords} Only`;
  return `INR ${rupeesWords} and ${numberToWordsIndian(paise)} Paise Only`;
};

const DEFAULT_VENDOR_MOU_PAGES = ({ companyName, companyAddress, companyGst, companyEmail, distributorName, distributorAddress }) => [
  [
    `Memorandum of Understanding (MOU) between ${companyName.toUpperCase()} and distributors:`,
    ``,
    `MEMORANDUM OF UNDERSTANDING:`,
    ``,
    `This Memorandum of Understanding ("MOU") is made and entered into on ${fmtDate(new Date())} by and between:`,
    ``,
    `${companyName.toUpperCase()},`,
    `${companyAddress.toUpperCase()}`,
    ``,
    `With its registered office at:`,
    `${companyAddress.toUpperCase()}`,
    ``,
    `And`,
    ``,
    `[${distributorName || "DISTRIBUTOR NAME"}] ("Distributor")`,
    ``,
    `With its registered office at [${distributorAddress || "DISTRIBUTOR ADDRESS"}]`,
    ``,
    `WHEREAS, the Company is engaged in the business of trading and supplying rice; and`,
    ``,
    `WHEREAS, the Distributor is interested in distributing rice supplied by the Company.`,
    ``,
    `NOW, THEREFORE, in consideration of the mutual covenants and promises contained herein, the parties agree as follows:`,
    ``,
    `1. PURPOSE AND SCOPE`,
    `The purpose of this MOU is to outline the terms and conditions under which the Company will supply rice to the Distributor, and the Distributor will distribute and sell the rice in [TERRITORY].`,
    ``,
    `2. OBLIGATIONS OF THE COMPANY`,
    `The Company shall:`,
    `- Supply rice to the Distributor at the agreed prices and quantities;`,
    `- Ensure that the rice supplied meets the required quality standards;`,
    `- Provide the Distributor with marketing and promotional support.`,
    ``,
    `3. OBLIGATIONS OF THE DISTRIBUTOR`,
    `The Distributor shall:`,
    `- Purchase rice from the Company at the agreed prices and quantities;`,
    `- Distribute and sell the rice in [TERRITORY] only;`,
    `- Maintain accurate records of sales and inventory;`,
    `- Make payments to the Company within the agreed payment terms.`,
  ],
  [
    `4. TERM AND TERMINATION`,
    `The term of this MOU shall commence on the Effective Date and shall continue for a period of [TERM] years. Either party may terminate this MOU upon 30 days' written notice to the other party.`,
    `The distributor will have to make payment only up to the invoice value within 7 days from the delivery date. If the payment is made after 7 days, then the invoice value along with 18% of the invoice value will have to be paid.`,
    `If the distributor does not make the payment for 30 days, his dealership will be cancelled. Also, the security deposit will not be returned for which the distributor cannot take any legal action against the company.`,
    ``,
    `5. CONFIDENTIALITY`,
    `The parties shall keep confidential all information and materials provided by each other, including but not limited to pricing, marketing strategies, and customer lists.`,
    ``,
    `6. GOVERNING LAW AND JURISDICTION`,
    `This MOU shall be governed by and construed in accordance with the laws of [COUNTRY/STATE]. Any disputes arising out of or in connection with this MOU shall be resolved through arbitration in accordance with the rules of [ARBITRATION ASSOCIATION].`,
    ``,
    `IN WITNESS WHEREOF, the parties have executed this MOU as of the date first above written.`,
    ``,
    `${companyName.toUpperCase()}`,
    `By: ____________________`,
    `Title: ____________________`,
    `Date: ____________________`,
    ``,
    `[${distributorName || "DISTRIBUTOR NAME"}]`,
    `By: ____________________`,
    `Title: ____________________`,
    `Date: ____________________`,
    ``,
    `E-mail : ${companyEmail}`,
  ],
];

let cachedLogoDataUrl = "";

const loadImageDataUrl = async (src) => {
  if (cachedLogoDataUrl) return cachedLogoDataUrl;
  const res = await fetch(src);
  const blob = await res.blob();
  const dataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(String(reader.result || ""));
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
  cachedLogoDataUrl = dataUrl;
  return dataUrl;
};

const addHeading = (doc, title) => {
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(String(title || ""), 14, 18);
  doc.setDrawColor(220, 226, 235);
  doc.line(14, 22, 196, 22);
  return 30;
};

const addKV = (doc, label, value, y) => {
  const safeValue = value == null || value === "" ? "-" : String(value);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10.4);
  doc.text(`${label}:`, 14, y);
  doc.setFont("helvetica", "normal");
  const lines = doc.splitTextToSize(safeValue, 135);
  doc.text(lines, 52, y);
  return y + Math.max(6, lines.length * 5.2);
};

const createVendorAgreementPdf = async ({ vendor = {}, financialSummary = {}, assignedManager = null }) => {
  const doc = new jsPDF("p", "mm", "a4");
  const pageWidth = 210;
  const pageHeight = 297;
  const left = 12;
  const right = 198;
  const width = right - left;
  const bottomLimit = 282;
  const primary = [15, 15, 189];
  const primarySoft = [239, 243, 255];
  const ink = [15, 23, 42];
  const slate = [71, 85, 105];
  const mute = [148, 163, 184];
  const line = [226, 232, 240];
  const soft = [248, 250, 252];
  const success = [22, 163, 74];
  const danger = [220, 38, 38];
  const watermark = [15, 23, 42];
  let page = 1;
  let y = 12;

  const company = {
    name: vendor?.agreementCompanyName || "Lotus Rice Mill Pvt. Ltd.",
    address:
      vendor?.agreementCompanyAddress ||
      "Old Agro Road, Saraiya, Chungi More, Tiraha, Etawah, UP 206001",
    gst: vendor?.agreementCompanyGST || "09XXXXX0000X1ZX",
    email: vendor?.agreementCompanyEmail || "lotusrice.in@yahoo.com",
  };

  const distributorName = vendor?.companyName || vendor?.fullName || "Vendor / Distributor";
  const distributorAddress = vendor?.address || vendor?.geoLocation?.address || "-";
  const distributorGST = vendor?.gstNumber || "-";
  const distributorPAN = vendor?.panNumber || "-";
  const agreementDate = fmtDate(vendor?.agreementLastUpdatedAt || new Date());
  const effectiveDate =
    vendor?.agreementAcceptedByAdminAt || vendor?.agreementAcceptedByVendorAt || vendor?.agreementLastUpdatedAt;
  const agreementDocumentId = `LRI-MOU-${new Date(vendor?.agreementLastUpdatedAt || Date.now()).getFullYear()}-${String(
    vendor?.agreementVersion || 1
  ).padStart(4, "0")}`;
  const adminSigner = vendor?.agreementAcceptedByAdminName || "Authorized Signatory";
  const vendorSigner = vendor?.agreementAcceptedByVendorName || vendor?.contactName || distributorName;
  const adminSignatureImage = isImageDataUrl(vendor?.agreementAcceptedByAdminSignature)
    ? String(vendor.agreementAcceptedByAdminSignature)
    : "";
  const vendorSignatureImage = isImageDataUrl(vendor?.agreementAcceptedByVendorSignature)
    ? String(vendor.agreementAcceptedByVendorSignature)
    : "";
  const agreementPages = DEFAULT_VENDOR_MOU_PAGES({
    companyName: company.name,
    companyAddress: company.address,
    companyGst: company.gst,
    companyEmail: company.email,
    distributorName,
    distributorAddress,
  });

  const drawPageShell = (logoDataUrl = "") => {
    doc.setFillColor(...soft);
    doc.rect(0, 0, pageWidth, pageHeight, "F");
    doc.setFillColor(255, 255, 255);
    doc.roundedRect(left, 8, width, 279, 5, 5, "F");
    doc.setDrawColor(...line);
    doc.setLineWidth(0.35);
    doc.roundedRect(left, 8, width, 279, 5, 5, "S");
    if (logoDataUrl) {
      try {
        doc.saveGraphicsState();
        doc.setGState(new doc.GState({ opacity: 0.08 }));
        doc.addImage(logoDataUrl, "PNG", 55, 88, 100, 100);
        doc.restoreGraphicsState();
      } catch {}
    }
    doc.setTextColor(...ink);
  };

  const drawHeader = (logoDataUrl = "") => {
    const top = 18;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(19);
    doc.setTextColor(20, 77, 38);
    doc.text(company.name, left + 10, top + 4);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(6.6);
    doc.setTextColor(...ink);
    doc.text(split(company.address, 70), left + 10, top + 9);
    doc.text(`GSTIN: ${company.gst}`, left + 10, top + 17);
    doc.text(`E-mail: ${company.email}`, left + 10, top + 21);

    if (logoDataUrl) {
      try {
        doc.addImage(logoDataUrl, "PNG", right - 26, top - 1, 18, 18);
      } catch {}
    }

    doc.setDrawColor(150, 160, 170);
    doc.line(left + 8, top + 25, right - 8, top + 25);
    doc.setTextColor(...ink);
  };

  const drawFooter = () => {
    doc.setDrawColor(...line);
    doc.line(left + 4, 279, right - 4, 279);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7.2);
    doc.setTextColor(...mute);
    doc.text(`Agreement Version: ${Number(vendor?.agreementVersion || 1)}`, left + 5, 284);
    doc.text(`Generated on ${new Date().toLocaleString("en-IN")}`, 105, 284, { align: "center" });
    doc.text(`Page ${page}`, right - 5, 284, { align: "right" });
    doc.setTextColor(...ink);
  };

  const startPage = (logoDataUrl = "") => {
    drawPageShell(logoDataUrl);
    drawFooter();
    drawHeader(logoDataUrl);
    y = 52;
  };

  const addPage = (logoDataUrl = "") => {
    doc.addPage();
    page += 1;
    startPage(logoDataUrl);
  };

  const ensureSpace = (need = 16) => {
    if (y + need <= bottomLimit) return;
    addPage(cachedLogoDataUrl);
  };

  const split = (text, w = width - 12) => doc.splitTextToSize(String(text || ""), w);
  const addParagraph = (text, opts = {}) => {
    const x = opts.x ?? left + 6;
    const w = opts.w ?? width - 12;
    const size = opts.size ?? 9.2;
    const color = opts.color ?? slate;
    const gap = opts.gap ?? 4.9;
    const weight = opts.weight || "normal";
    const lines = split(text, w);
    ensureSpace(lines.length * gap + 2);
    doc.setFont("helvetica", weight);
    doc.setFontSize(size);
    doc.setTextColor(...color);
    doc.text(lines, x, y);
    y += lines.length * gap;
    doc.setTextColor(...ink);
  };

  const drawStatusStamp = ({ text, color, x, top, w, angle }) => {
    doc.setDrawColor(...color);
    doc.setTextColor(...color);
    doc.roundedRect(x, top, w, 10, 2, 2, "S");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text(text, x + w / 2, top + 6.8, { align: "center", angle });
    doc.setTextColor(...ink);
  };

  const drawTopSectionTitle = (title) => {
    ensureSpace(10);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8.8);
    doc.setTextColor(...primary);
    doc.text(title, left + 10, y);
    y += 2.8;
    doc.setDrawColor(...line);
    doc.setLineWidth(0.5);
    doc.line(left + 10, y + 1.2, right - 10, y + 1.2);
    y += 7;
    doc.setTextColor(...ink);
  };

  let logoDataUrl = "";
  try {
    logoDataUrl = await loadImageDataUrl(logo);
  } catch {}
  startPage(logoDataUrl);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text(`Memorandum of Understanding (MOU) between ${company.name.toUpperCase()} and distributors:`, left + 10, y);
  y += 8;
  doc.text("MEMORANDUM OF UNDERSTANDING:", left + 10, y);
  y += 8;

  drawTopSectionTitle("1. PARTIES INVOLVED");

  agreementPages.forEach((pageLines, pageIndex) => {
    if (pageIndex > 0) {
      addPage(logoDataUrl);
      drawTopSectionTitle(pageIndex === 1 ? "4. TERM AND TERMINATION" : `PAGE ${pageIndex + 1}`);
    }

    pageLines.forEach((term) => {
      const isHeading = /^[0-9]+\./.test(term) || /^[A-Z][A-Z\s()&:.-]{6,}$/.test(term);
      if (!term) {
        y += 3;
        return;
      }
      if (pageIndex === 0 && /^1\./.test(term)) return;
      if (pageIndex === 1 && /^4\./.test(term)) return;
      addParagraph(term, {
        x: left + 10,
        w: width - 20,
        size: isHeading ? 8.7 : 8.2,
        gap: 4.4,
        weight: isHeading ? "bold" : "normal",
        color: ink,
      });
    });
  });

  ensureSpace(56);
  const signTop = y;
  const signW = 84;
  doc.setFillColor(250, 251, 253);
  doc.setDrawColor(...line);
  doc.roundedRect(left + 6, signTop, signW, 44, 4, 4, "FD");
  doc.roundedRect(left + 96, signTop, signW, 44, 4, 4, "FD");

  doc.setFont("helvetica", "bold");
  doc.setFontSize(7.8);
  doc.setTextColor(...mute);
  doc.text("AUTHORIZED SIGNATORY (ADMIN)", left + 10, signTop + 6);
  doc.text("SECOND PARTY (VENDOR)", left + 100, signTop + 6);

  doc.setDrawColor(203, 213, 225);
  doc.line(left + 10, signTop + 26, left + 80, signTop + 26);
  doc.line(left + 100, signTop + 26, left + 170, signTop + 26);

  if (adminSignatureImage) {
    try {
      doc.addImage(adminSignatureImage, "PNG", left + 12, signTop + 11, 36, 12);
    } catch {}
  } else {
    doc.setFont("times", "italic");
    doc.setFontSize(15);
    doc.setTextColor(...ink);
    doc.text(adminSigner, left + 12, signTop + 23);
  }

  if (vendorSignatureImage) {
    try {
      doc.addImage(vendorSignatureImage, "PNG", left + 102, signTop + 11, 36, 12);
    } catch {}
  } else {
    doc.setFont("times", "italic");
    doc.setFontSize(15);
    doc.setTextColor(...ink);
    doc.text(vendorSigner, left + 102, signTop + 23);
  }

  if (vendor?.agreementAcceptedByAdmin) {
    drawStatusStamp({
      text: "DIGITALLY ACCEPTED",
      color: success,
      x: left + 18,
      top: signTop + 11,
      w: 50,
      angle: 348,
    });
  }
  if (vendor?.agreementAcceptedByVendor) {
    drawStatusStamp({
      text: "ACCEPTED",
      color: primary,
      x: left + 118,
      top: signTop + 11,
      w: 32,
      angle: 8,
    });
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(8.4);
  doc.setTextColor(...ink);
  doc.text(adminSigner, left + 10, signTop + 32);
  doc.text(vendorSigner, left + 100, signTop + 32);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7.6);
  doc.setTextColor(...slate);
  doc.text(`Date: ${fmtDate(vendor?.agreementAcceptedByAdminAt || effectiveDate)}`, left + 10, signTop + 37);
  doc.text(vendor?.agreementAcceptedByAdmin ? "Verified" : "Pending", left + 10, signTop + 41);
  doc.text(`Date: ${fmtDate(vendor?.agreementAcceptedByVendorAt || effectiveDate)}`, left + 100, signTop + 37);
  doc.text(vendor?.agreementAcceptedByVendor ? "Verified" : "Pending", left + 100, signTop + 41);

  drawFooter();
  return { doc, distributorName };
};

export const downloadVendorAgreementPdf = async ({ vendor = {}, financialSummary = {}, assignedManager = null }) => {
  const { doc, distributorName } = await createVendorAgreementPdf({ vendor, financialSummary, assignedManager });
  doc.save(`Vendor_Agreement_${(distributorName || "Vendor").replace(/\s+/g, "_")}.pdf`);
};

export const openVendorAgreementPreview = async ({ vendor = {}, financialSummary = {}, assignedManager = null }) => {
  const { doc } = await createVendorAgreementPdf({ vendor, financialSummary, assignedManager });
  const blobUrl = doc.output("bloburl");
  window.open(blobUrl, "_blank", "noopener,noreferrer");
};

export const downloadVendorInvoicePdf = async ({ requirement = {}, vendor = {} }) => {
  const doc = new jsPDF("p", "mm", "a4");
  const reqId = String(requirement?._id || "").slice(-6).toUpperCase() || "NA";
  const invoiceNo = requirement?.invoiceNo || `INV-REQ-${reqId}`;
  const invoiceDate = fmtDate(requirement?.invoiceDate || requirement?.createdAt || new Date());

  const vendorName = vendor?.companyName || vendor?.name || "Vendor Company";
  const vendorContact = vendor?.contact || "-";
  const vendorAddress = vendor?.address || vendor?.location || "Address not available";
  const vendorGST = vendor?.gstNumber || vendor?.gstin || "-";
  const vendorPAN = vendor?.panNumber || "-";
  const issuer = {
    ...INVOICE_ISSUER,
    name: requirement?.issuerName || vendor?.agreementCompanyName || INVOICE_ISSUER.name,
    address: requirement?.issuerAddress || vendor?.agreementCompanyAddress || INVOICE_ISSUER.address,
    gst: requirement?.issuerGST || vendor?.agreementCompanyGST || INVOICE_ISSUER.gst,
    email: requirement?.issuerEmail || vendor?.agreementCompanyEmail || INVOICE_ISSUER.email,
    phone: requirement?.issuerPhone || INVOICE_ISSUER.phone,
    pan: requirement?.issuerPAN || INVOICE_ISSUER.pan,
    bankName: requirement?.issuerBankName || INVOICE_ISSUER.bankName,
    bankBranch: requirement?.issuerBankBranch || INVOICE_ISSUER.bankBranch,
    bankAccount: requirement?.issuerBankAccount || INVOICE_ISSUER.bankAccount,
    bankIfsc: requirement?.issuerBankIfsc || INVOICE_ISSUER.bankIfsc,
    upiId: requirement?.issuerUpiId || INVOICE_ISSUER.upiId,
    signatoryName: requirement?.issuerSignatoryName || INVOICE_ISSUER.signatoryName,
  };

  const buyerName =
    requirement?.billToName ||
    requirement?.customerName ||
    requirement?.buyerName ||
    vendorName ||
    "Buyer";
  const buyerAddress =
    requirement?.billToAddress ||
    requirement?.customerAddress ||
    requirement?.buyerAddress ||
    vendorAddress ||
    requirement?.location?.address ||
    requirement?.location ||
    "Buyer address not available";
  const buyerGST = requirement?.billToGST || requirement?.customerGST || requirement?.buyerGST || requirement?.buyerGstin || vendorGST || "-";
  const buyerPAN = requirement?.billToPAN || requirement?.customerPAN || requirement?.buyerPAN || vendorPAN || "-";
  const poNumber = requirement?.poNumber || requirement?.purchaseOrderNo || "-";
  const poDate = fmtDate(requirement?.poDate || requirement?.createdAt);
  const eWayNo = requirement?.eWayNo || requirement?.ewayNo || requirement?.dispatch?.trackingId || "-";
  const dueDate = fmtDate(requirement?.dueDate);
  const currency = requirement?.currency || "INR";
  const paymentTerms =
    requirement?.paymentTerms ||
    requirement?.creditTerms?.label ||
    `${Number(requirement?.paymentDueDays || 0) || 0} Days`;
  const placeOfSupply = requirement?.placeOfSupply || requirement?.location?.address || "-";
  const issueState = requirement?.buyerState || requirement?.state || "-";

  const defaultItems = [
    {
      description: requirement?.productType || "Product / Service",
      qty: Number(requirement?.quantity || 1) || 1,
      unit: String(requirement?.unit || "Unit"),
      rate:
        Number(requirement?.creditTerms?.baseAmount || requirement?.requirementAmount || 0) /
          (Number(requirement?.quantity || 1) || 1) || 0,
      taxPercent: Number(requirement?.gstPercent || requirement?.taxPercent || 18) || 0,
      amount: Number(requirement?.creditTerms?.baseAmount || requirement?.requirementAmount || 0) || 0,
      hsnSac: requirement?.hsnSac || "-",
    },
  ];
  const rawItems = Array.isArray(requirement?.items) && requirement.items.length ? requirement.items : defaultItems;
  const items = rawItems.map((item, index) => {
    const itemQty = Number(item?.qty ?? item?.quantity ?? 1) || 1;
    const itemTaxPercent = Number(item?.taxPercent ?? item?.gstPercent ?? requirement?.gstPercent ?? requirement?.taxPercent ?? 18) || 0;
    const itemSubtotalCandidate = [
      item?.lineSubtotal,
      item?.subtotalAmount,
      item?.baseAmount,
      item?.taxableValue,
      item?.amount,
      item?.requirementAmount,
    ]
      .map((value) => Number(value))
      .find((value) => Number.isFinite(value));
    const itemSubtotal = Number.isFinite(itemSubtotalCandidate)
      ? itemSubtotalCandidate
      : itemQty * (Number(item?.rate || 0) || 0);
    const itemRate = Number(item?.rate || 0) || (itemQty > 0 ? itemSubtotal / itemQty : itemSubtotal);
    const itemTaxCandidate = [item?.lineTax, item?.gstAmount, item?.taxAmount]
      .map((value) => Number(value))
      .find((value) => Number.isFinite(value));
    const itemTax = Number.isFinite(itemTaxCandidate) ? itemTaxCandidate : (itemSubtotal * itemTaxPercent) / 100;
    const itemTotalCandidate = [item?.lineTotal, item?.totalAmount]
      .map((value) => Number(value))
      .find((value) => Number.isFinite(value));
    const itemTotal = Number.isFinite(itemTotalCandidate) ? itemTotalCandidate : itemSubtotal + itemTax;
    return {
      sr: index + 1,
      description: String(item?.description || item?.productType || "Product / Service"),
      qty: itemQty,
      unit: String(item?.unit || "Unit"),
      rate: itemRate,
      taxableValue: itemSubtotal,
      taxPercent: itemTaxPercent,
      taxAmount: itemTax,
      total: itemTotal,
      hsnSac: String(item?.hsnSac || requirement?.hsnSac || "-"),
    };
  });

  const taxableValue = items.reduce((sum, item) => sum + Number(item.taxableValue || 0), 0);
  const taxAmount = items.reduce((sum, item) => sum + Number(item.taxAmount || 0), 0);
  const safeGstPercent = Number(requirement?.gstPercent || requirement?.taxPercent || items[0]?.taxPercent || 18) || 0;
  const isInterState = Boolean(requirement?.isInterState || requirement?.igstOnly);
  const cgstPercent = isInterState ? 0 : safeGstPercent / 2;
  const sgstPercent = isInterState ? 0 : safeGstPercent / 2;
  const igstPercent = isInterState ? safeGstPercent : 0;
  const cgstAmount = (taxableValue * cgstPercent) / 100;
  const sgstAmount = (taxableValue * sgstPercent) / 100;
  const igstAmount = (taxableValue * igstPercent) / 100;
  const totalAmount = Number(requirement?.totalAmount || requirement?.amount || taxableValue + taxAmount) || 0;
  const totalQty = items.reduce((sum, item) => sum + Number(item.qty || 0), 0);
  const invoiceStatus = String(requirement?.invoiceStatus || requirement?.status || "generated")
    .replace(/[_-]+/g, " ")
    .replace(/\b\w/g, (ch) => ch.toUpperCase());

  const money = (n) =>
    Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const splitSafe = (text, w) => doc.splitTextToSize(String(text || "-"), w);
  const mmToWords = (n) => (currency === "INR" ? amountToWordsInr(n) : `${currency} ${money(n)} Only`);
  const left = 8;
  const right = 202;
  const pageWidth = 210;
  const pageHeight = 297;
  const ink = [20, 24, 32];
  const slate = [71, 85, 105];
  const muted = [100, 116, 139];
  const border = [37, 99, 235];
  const brand = [29, 78, 216];
  const lightFill = [239, 246, 255];
  const softerFill = [248, 250, 252];
  const top = 10;
  const innerWidth = right - left;
  const shipToName = requirement?.shipToName || vendorName || buyerName;
  const shipToAddress = requirement?.shipToAddress || vendorAddress || buyerAddress;
  const shipToGST = requirement?.shipToGST || vendorGST || buyerGST;
  const shipToPAN = requirement?.shipToPAN || vendorPAN || buyerPAN;
  const sellerLines = [
    issuer.address,
    `GSTIN: ${issuer.gst}`,
    `Phone: ${issuer.phone}`,
    `Email: ${issuer.email}`,
  ].filter(Boolean);
  const buyerLines = [
    ...splitSafe(buyerAddress, 46),
    `GSTIN: ${buyerGST}`,
    `PAN: ${buyerPAN}`,
    `State: ${issueState}`,
  ];
  const shipLines = [
    ...splitSafe(shipToAddress, 46),
    `GSTIN: ${shipToGST}`,
    `PAN: ${shipToPAN}`,
    `State: ${requirement?.shipState || "-"}`,
  ];
  const detailRows = [
    ["Invoice No", invoiceNo],
    ["Invoice Date", invoiceDate],
    ["Due Date", dueDate],
    ["PO Number", poNumber],
    ["PO Date", poDate],
    ["E-Way No", eWayNo],
    ["Currency", currency],
    ["Payment Terms", paymentTerms],
  ];

  doc.setFillColor(255, 255, 255);
  doc.rect(0, 0, pageWidth, pageHeight, "F");
  doc.setDrawColor(...border);
  doc.setLineWidth(0.5);
  doc.rect(left, top, innerWidth, 274, "S");
  doc.setFillColor(...softerFill);
  doc.rect(left + 0.5, top + 0.5, innerWidth - 1, 28, "F");

  try {
    const logoDataUrl = await loadImageDataUrl(logo);
    doc.addImage(logoDataUrl, "PNG", left + 4, top + 4, 18, 18);
  } catch {}

  doc.setTextColor(...ink);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13.5);
  doc.text(issuer.name, left + 27, top + 8);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7.4);
  doc.setTextColor(...slate);
  doc.text(splitSafe(issuer.address, 62), left + 27, top + 13);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(7.1);
  doc.text(`GSTIN: ${issuer.gst}`, left + 27, top + 23.5);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(7.1);
  doc.setTextColor(...ink);
  const contactBoxX = right - 50;
  const contactLabelX = contactBoxX + 2;
  const contactValueX = contactBoxX + 18;
  const contactValueWidth = 15;
  doc.text("Name:", contactLabelX, top + 6);
  doc.text("Phone:", contactLabelX, top + 11);
  doc.text("Email:", contactLabelX, top + 16);
  doc.text("Website:", contactLabelX, top + 21);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(6.1);
  doc.setTextColor(...slate);
  doc.text(splitSafe(String(buyerName || "-"), contactValueWidth), contactValueX, top + 6, { align: "left" });
  doc.text(splitSafe(String(vendorContact || "-"), contactValueWidth), contactValueX, top + 11, { align: "left" });
  doc.text(splitSafe(String(issuer.email || "-"), contactValueWidth), contactValueX, top + 16, { align: "left" });
  doc.text(splitSafe("www.lotusrice.in", contactValueWidth), contactValueX, top + 21, { align: "left" });

  const titleY = top + 28;
  doc.setFillColor(...lightFill);
  doc.rect(left, titleY, innerWidth, 8, "F");
  doc.rect(left, titleY, innerWidth, 8, "S");
  doc.line(left + 74, titleY, left + 74, titleY + 8);
  doc.line(right - 38, titleY, right - 38, titleY + 8);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.setTextColor(...ink);
  doc.text(`GSTIN : ${issuer.gst}`, left + 2, titleY + 5.3);
  doc.text("TAX INVOICE", 105, titleY + 5.3, { align: "center" });
  doc.setFontSize(6.4);
  doc.text("ORIGINAL FOR RECIPIENT", right - 19, titleY + 5.2, { align: "center" });

  let y = titleY + 8;
  const leftBoxWidth = 78;
  const rightBoxWidth = innerWidth - leftBoxWidth;
  const detailsTop = y;
  const detailRowHeight = 5.4;
  const detailBoxHeight = 8 + detailRows.length * detailRowHeight;
  const buyerBoxHeight = Math.max(
    detailBoxHeight,
    16 + Math.max(buyerLines.length, shipLines.length) * 4.2
  );

  doc.rect(left, y, leftBoxWidth, buyerBoxHeight, "S");
  doc.rect(left + leftBoxWidth, y, rightBoxWidth, buyerBoxHeight, "S");
  doc.line(left + leftBoxWidth / 2, y, left + leftBoxWidth / 2, y + buyerBoxHeight);
  doc.setFillColor(...softerFill);
  doc.rect(left + 0.4, y + 0.4, leftBoxWidth - 0.8, 7, "F");
  doc.rect(left + leftBoxWidth + 0.4, y + 0.4, rightBoxWidth - 0.8, 7, "F");
  doc.line(left + leftBoxWidth / 2, y, left + leftBoxWidth / 2, y + buyerBoxHeight);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);
  doc.setTextColor(...brand);
  doc.text("BILL TO", left + 3, y + 6);
  doc.text("SHIP TO", left + leftBoxWidth / 2 + 3, y + 6);
  doc.text("INVOICE DETAILS", left + leftBoxWidth + 3, y + 6);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.setTextColor(...ink);
  doc.text(splitSafe(buyerName, 32), left + 3, y + 12);
  doc.text(splitSafe(shipToName, 32), left + leftBoxWidth / 2 + 3, y + 12);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(7.2);
  doc.setTextColor(...slate);
  doc.text(buyerLines, left + 3, y + 17);
  doc.text(shipLines, left + leftBoxWidth / 2 + 3, y + 17);

  let detailY = y + 10.5;
  detailRows.forEach(([label, value]) => {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(6.9);
    doc.setTextColor(...muted);
    doc.text(label, left + leftBoxWidth + 3, detailY);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7.2);
    doc.setTextColor(...ink);
    doc.text(splitSafe(value, 21), left + leftBoxWidth + 29, detailY);
    detailY += detailRowHeight;
  });

  y += buyerBoxHeight;
  const tableY = y;
  const tableCols = [8, 66, 20, 14, 16, 22, 22, 24];
  const tableStarts = [left];
  for (let i = 0; i < tableCols.length - 1; i += 1) tableStarts.push(tableStarts[i] + tableCols[i]);
  const headers = ["Sr.", "Description", "HSN/SAC", "Qty", "Unit", "Rate", "Taxable", "Total"];

  doc.setFillColor(...lightFill);
  doc.rect(left, tableY, innerWidth, 8, "F");
  doc.rect(left, tableY, innerWidth, 8, "S");
  tableStarts.slice(1).forEach((x) => doc.line(x, tableY, x, tableY + 8));
  doc.setFont("helvetica", "bold");
  doc.setFontSize(6.6);
  doc.setTextColor(...ink);
  headers.forEach((header, index) => {
    const x = tableStarts[index] + 2;
    doc.text(header, x, tableY + 5.3);
  });

  y = tableY + 8;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(6.8);
  items.forEach((item) => {
    const descLines = splitSafe(item.description, 28);
    const rowHeight = Math.max(8, descLines.length * 3.5 + 2);
    doc.rect(left, y, innerWidth, rowHeight, "S");
    tableStarts.slice(1).forEach((x) => doc.line(x, y, x, y + rowHeight));
    doc.text(String(item.sr), tableStarts[0] + 2, y + 4.8);
    doc.text(descLines, tableStarts[1] + 2, y + 4.2);
    doc.text(item.hsnSac, tableStarts[2] + 2, y + 4.8);
    doc.text(Number(item.qty || 0).toFixed(2), tableStarts[3] + 2, y + 4.8);
    doc.text(item.unit, tableStarts[4] + 2, y + 4.8);
    doc.text(money(item.rate), tableStarts[5] + tableCols[5] - 2, y + 4.8, { align: "right" });
    doc.text(money(item.taxableValue), tableStarts[6] + tableCols[6] - 2, y + 4.8, { align: "right" });
    doc.setFont("helvetica", "bold");
    doc.text(money(item.total), tableStarts[7] + tableCols[7] - 2, y + 4.8, { align: "right" });
    doc.setFont("helvetica", "normal");
    y += rowHeight;
  });

  const totalsRows = [
    ["Sub Total", money(taxableValue)],
    [isInterState ? `IGST (${igstPercent.toFixed(2)}%)` : `CGST (${cgstPercent.toFixed(2)}%)`, money(isInterState ? igstAmount : cgstAmount)],
    [isInterState ? "Tax Total" : `SGST (${sgstPercent.toFixed(2)}%)`, money(isInterState ? taxAmount : sgstAmount)],
    ["Grand Total", money(totalAmount)],
  ];

  const totalsStartY = y;
  const totalsLeftWidth = 116;
  const totalsRightX = left + totalsLeftWidth;
  const totalsHeight = 34;
  doc.rect(left, totalsStartY, innerWidth, totalsHeight, "S");
  doc.line(totalsRightX, totalsStartY, totalsRightX, totalsStartY + totalsHeight);
  doc.setFillColor(...softerFill);
  doc.rect(left + 0.4, totalsStartY + 0.4, innerWidth - 0.8, 7, "F");

  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);
  doc.setTextColor(...brand);
  doc.text("TOTAL IN WORDS", left + 3, totalsStartY + 6);
  doc.text("SUMMARY", totalsRightX + 3, totalsStartY + 6);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7.1);
  doc.setTextColor(...ink);
  doc.text(splitSafe(mmToWords(totalAmount), 108), left + 3, totalsStartY + 12);

  let totalsY = totalsStartY + 12;
  totalsRows.forEach(([label, value], index) => {
    const isGrand = index === totalsRows.length - 1;
    doc.setFont("helvetica", isGrand ? "bold" : "normal");
    doc.setFontSize(isGrand ? 8.2 : 7.2);
    doc.text(label, totalsRightX + 3, totalsY);
    doc.text(value, right - 3, totalsY, { align: "right" });
    doc.line(totalsRightX + 2, totalsY + 2, right - 2, totalsY + 2);
    totalsY += 6;
  });

  y = totalsStartY + totalsHeight;
  const bottomHeight = 42;
  doc.rect(left, y, innerWidth, bottomHeight, "S");
  doc.line(left + 110, y, left + 110, y + bottomHeight);
  doc.setFillColor(...softerFill);
  doc.rect(left + 0.4, y + 0.4, innerWidth - 0.8, 7, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);
  doc.setTextColor(...brand);
  doc.text("BANK DETAILS", left + 3, y + 6);
  doc.text("FOR LOTUS RICE MILL PVT. LTD.", left + 113, y + 6);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(7.1);
  doc.setTextColor(...ink);
  const bankLines = [
    `Bank: ${issuer.bankName}`,
    `Branch: ${issuer.bankBranch}`,
    `A/C No: ${issuer.bankAccount}`,
    `IFSC: ${issuer.bankIfsc}`,
    `UPI: ${issuer.upiId}`,
  ];
  doc.text(bankLines, left + 3, y + 12);

  const terms = splitSafe(
    requirement?.invoiceTerms ||
      "Subject to jurisdiction. Goods once sold will not be taken back. Delivery ex-premises.",
    56
  );
  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);
  doc.setTextColor(...brand);
  doc.text("TERMS", left + 3, y + 31);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(6.6);
  doc.setTextColor(...slate);
  doc.text(terms, left + 3, y + 36);

  doc.setDrawColor(...border);
  doc.line(left + 123, y + 28, right - 8, y + 28);
  doc.setFont("times", "italic");
  doc.setFontSize(12);
  doc.setTextColor(...ink);
  doc.text("e-sign", left + 145, y + 24, { align: "center" });
  doc.setFont("helvetica", "bold");
  doc.setFontSize(7.4);
  doc.text(issuer.signatoryName, left + 145, y + 33, { align: "center" });
  doc.setFont("helvetica", "normal");
  doc.setFontSize(6.8);
  doc.setTextColor(...muted);
  doc.text("Authorised Signatory", left + 145, y + 38, { align: "center" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);
  doc.setTextColor(...muted);
  doc.text(`Generated on ${new Date().toLocaleString("en-IN")}`, left + 2, 288);
  doc.text(`Reference ID: ${reqId}`, 105, 288, { align: "center" });
  doc.text("Page 1", right - 2, 288, { align: "right" });
  doc.save(`Vendor_Invoice_REQ_${reqId}.pdf`);
};

export const downloadAccountsInvoicePdf = async ({ invoice = {} }) => {
  const invoiceId = String(invoice?._id || "").slice(-6).toUpperCase() || "NA";
  const dispatch = invoice?.dispatchDetails || {};
  const items = Array.isArray(invoice?.items) ? invoice.items : [];
  const taxableValue = Number(invoice?.subtotal || 0);
  const gstAmount = Number(invoice?.taxAmount || 0);
  const firstTaxPercent = Number(items?.[0]?.taxPercent || 0);

  const requirementLike = {
    _id: invoice?._id || invoiceId,
    invoiceNo: invoice?.invoiceNo || `INV-${invoiceId}`,
    invoiceDate: invoice?.invoiceDate || invoice?.createdAt || new Date(),
    dueDate: invoice?.dueDate,
    createdAt: invoice?.createdAt || new Date(),
    productType: items?.[0]?.description || "Product / Service",
    quantity: items.reduce((sum, item) => sum + Number(item?.qty || item?.quantity || 0), 0) || 1,
    unit: items?.[0]?.unit || "Unit",
    subtotalAmount: taxableValue,
    gstAmount,
    requirementAmount: Number(invoice?.totalAmount || invoice?.amount || taxableValue + gstAmount || 0),
    totalAmount: Number(invoice?.totalAmount || invoice?.amount || taxableValue + gstAmount || 0),
    gstPercent: firstTaxPercent,
    taxPercent: firstTaxPercent,
    paymentTerms: invoice?.dueDate ? `Due by ${fmtDate(invoice.dueDate)}` : "As per agreed terms",
    poNumber: dispatch?.purchaseOrderNo || "-",
    purchaseOrderNo: dispatch?.purchaseOrderNo || "-",
    eWayNo: dispatch?.trackingId || invoice?.referenceNo || "-",
    buyerName: invoice?.vendor || "Buyer",
    billToName: invoice?.vendor || "Buyer",
    buyerAddress: dispatch?.locationAddress || dispatch?.currentLocation || "-",
    billToAddress: dispatch?.locationAddress || dispatch?.currentLocation || "-",
    shipToName: invoice?.vendor || "Buyer",
    shipToAddress: dispatch?.locationAddress || dispatch?.currentLocation || "-",
    items: items.map((item) => ({
      description: item?.description || "",
      qty: Number(item?.qty || item?.quantity || 0),
      unit: item?.unit || "",
      rate: Number(item?.rate || 0),
      taxPercent: Number(item?.taxPercent || 0),
      lineSubtotal: Number(item?.lineSubtotal || 0),
      lineTax: Number(item?.lineTax || 0),
      lineTotal: Number(item?.lineTotal || 0),
      hsnSac: item?.hsnSac || "-",
    })),
    notes: invoice?.notes || "",
    invoiceTerms: [invoice?.termsTitle, invoice?.notes].filter(Boolean).join(": "),
    issuerBankName: invoice?.bankDetails?.bankName || invoice?.bankName || "",
    issuerBankBranch: invoice?.bankDetails?.branch || "",
    issuerBankAccount: invoice?.bankDetails?.accountNumber || "",
    issuerBankIfsc: invoice?.bankDetails?.ifsc || "",
    issuerUpiId: invoice?.bankDetails?.upiId || "",
    dispatch: {
      trackingId: dispatch?.trackingId || invoice?.referenceNo || "",
    },
  };

  const vendorLike = {
    companyName: invoice?.vendor || "Buyer",
    name: invoice?.vendor || "Buyer",
    address: dispatch?.locationAddress || dispatch?.currentLocation || "-",
    location: dispatch?.locationAddress || dispatch?.currentLocation || "-",
    gstNumber: invoice?.buyerGST || "-",
    panNumber: "-",
    contact: dispatch?.driverMobile || "-",
  };

  return downloadVendorInvoicePdf({ requirement: requirementLike, vendor: vendorLike });
};

export const downloadSupplierPoPdf = ({ profile = {}, dispatches = [] }) => {
  const doc = new jsPDF("p", "mm", "a4");
  let y = addHeading(doc, "Purchase Order (Supplier)");
  const po = profile?.po || {};
  const totalValue =
    po?.totalValue != null
      ? Number(po.totalValue || 0)
      : Number(po.totalQty || 0) * Number(po.pricePerUnit || 0);
  const paidAmount = Number(po?.paidAmount || 0);
  const dueAmount = Math.max(0, totalValue - paidAmount);

  y = addKV(doc, "Supplier", profile.companyName || profile.supplierName || "Supplier", y);
  y = addKV(doc, "PO Number", po.poNumber || "-", y);
  y = addKV(doc, "Batch Number", po.batchNumber || "-", y);
  y = addKV(doc, "Product", po.productName || "-", y);
  y = addKV(doc, "Total Quantity", `${po.totalQty || "-"} ${po.unit || "ton"}`, y);
  y = addKV(doc, "Remaining Quantity", `${po.remainingQty ?? "-"} ${po.unit || "ton"}`, y);
  y = addKV(doc, "Rate", `${fmtMoney(po.pricePerUnit || 0)} per ${po.unit || "ton"}`, y);
  y = addKV(doc, "Total Value", fmtMoney(totalValue), y);
  y = addKV(doc, "Paid Amount", fmtMoney(paidAmount), y);
  y = addKV(doc, "Due Amount", fmtMoney(dueAmount), y);

  y += 2;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.text("Dispatch Summary", 14, y);
  y += 6;

  const relevant = Array.isArray(dispatches)
    ? dispatches.filter((d) => !po.poNumber || d.purchaseOrderNo === po.poNumber)
    : [];
  if (!relevant.length) {
    y = addKV(doc, "Entries", "No dispatch entries available", y);
  } else {
    const approved = relevant.filter((d) => String(d.approvalStatus || "").toLowerCase() === "approved").length;
    const pending = relevant.filter((d) => String(d.approvalStatus || "").toLowerCase() === "pending").length;
    const rejected = relevant.filter((d) => String(d.approvalStatus || "").toLowerCase() === "rejected").length;
    y = addKV(doc, "Total Dispatches", relevant.length, y);
    y = addKV(doc, "Approved/Pending/Rejected", `${approved}/${pending}/${rejected}`, y);
  }

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`Generated on ${new Date().toLocaleString("en-IN")}`, 14, Math.min(285, y + 8));
  doc.save(`Supplier_PO_${String(po.poNumber || "PO").replace(/[^\w-]/g, "_")}.pdf`);
};

export const downloadEmployeeAgreementPdf = async ({ employee = {} } = {}) => {
  const doc = new jsPDF("p", "mm", "a4");
  const pageWidth = 210;
  const pageHeight = 297;
  const left = 14;
  const right = pageWidth - 14;
  const contentWidth = right - left;
  const bottom = pageHeight - 18;
  let y = 18;

  const company = {
    name: "Lotus Rice Mills Pvt. Ltd.",
    address: "Old Agra Road, Saraiya Chungi Marg, Primary School, Etawah, Uttar Pradesh - 206001, India",
    gstin: "09AAGCL3528H1ZE",
    website: "www.lotusrice.in",
    email: "info@lotusrice.in",
    phone: "+91 9927999302",
    appLink: "https://lotusrice.in/",
    authorizedSignatoryName: "Director",
    authorizedSignatoryRole: "Authorized Signatory",
  };

  const agreement = employee?.employeeAgreement || {};
  const employeeName = employee?.fullName || "Employee";
  const departmentName = employee?.department?.name || employee?.departmentName || "assigned location";
  const employeeAddress =
    employee?.address || employee?.workProfile?.officeAddress || "Address to be updated in employee profile";
  const signedAt = agreement?.acceptedAt ? new Date(agreement.acceptedAt).toLocaleString("en-IN") : "Pending";

  const sections = [
    {
      title: "1. Probation / Trial Period",
      lines: [
        `${employeeName} will be kept on a 1-month trial period.`,
        "- If the employee's performance is satisfactory, they will continue as a regular employee.",
        "- If performance is not satisfactory, the company reserves the right to terminate the employee after the trial period.",
      ],
    },
    {
      title: "2. Work Commitment",
      lines: [
        `${employeeName} must work with full dedication, sincerity, and honesty. Proper discipline and punctuality must be maintained.`,
      ],
    },
    {
      title: "3. Monthly Target (Distributor Acquisition)",
      lines: [
        `${employeeName} agrees to the following monthly target:`,
        `- ${employeeName} must bring 10 distributors per month.`,
        `- All distributors must be from the ${departmentName}.`,
        "- Each distributor must deposit Rs. 50,000/- as advance for distributorship.",
        "- This is a fixed monthly target as discussed and agreed with the company.",
      ],
    },
    {
      title: "4. Salary & Performance-Based Payment",
      lines: [
        "Salary will be strictly based on target achievement:",
        "- 100% target completion: Full salary will be provided along with expenses.",
        "- 80% target completion: 80% of salary will be paid, and no expenses will be provided.",
        "- 50% target completion: 50% of salary will be paid, and no expenses will be provided.",
      ],
    },
    {
      title: "5. Working Hours",
      lines: [
        "- Working time: 8:00 AM to 8:00 PM.",
        "- Attendance must be marked through the Lotus application only.",
      ],
    },
    {
      title: "6. Confidentiality",
      lines: [
        `${employeeName} must not disclose any company data, business information, pricing, client details, or internal matters to any outsider.`,
      ],
    },
    {
      title: "7. Document Submission",
      lines: [
        `After receiving the appointment/offer letter, ${employeeName} must submit the following documents:`,
        "- Aadhaar card copy",
        "- PAN card copy",
        "- Bank account details",
        "- Graduation mark sheet",
        "- Resume",
        "- 1 passport size photograph",
      ],
    },
    {
      title: "8. Company Application System",
      lines: [
        `The company will provide a Lotus application link (${company.appLink}).`,
        "- All documents must be uploaded through the application.",
        "- Attendance will also be marked through this application.",
      ],
    },
    {
      title: "9. General Conduct",
      lines: [`${employeeName} must follow all company rules and maintain discipline at all times.`],
    },
  ];

  const ensureSpace = (needed = 12) => {
    if (y + needed <= bottom) return;
    doc.addPage();
    y = 18;
  };

  try {
    const logoData = await loadImageDataUrl(logo);
    doc.addImage(logoData, "PNG", left, y - 2, 24, 24);
  } catch (_err) {
    // logo load failure should not block PDF generation
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.text(company.name, left + 28, y + 6);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  const companyLines = doc.splitTextToSize(
    `${company.address}\nGSTIN: ${company.gstin} | Website: ${company.website}\nEmail: ${company.email} | Mobile: ${company.phone}`,
    120
  );
  doc.text(companyLines, left + 28, y + 12);

  doc.setDrawColor(210, 220, 230);
  doc.line(left, y + 28, right, y + 28);
  y += 38;

  doc.setFont("times", "bold");
  doc.setFontSize(22);
  doc.text("EMPLOYEE AGREEMENT", pageWidth / 2, y, { align: "center" });
  y += 10;
  doc.setFont("times", "normal");
  doc.setFontSize(12);
  const intro = doc.splitTextToSize(
    `This agreement is made between ${company.name} and ${employeeName}. Agreement version: ${Number(agreement?.version || 1)}.`,
    contentWidth
  );
  doc.text(intro, left, y);
  y += intro.length * 6 + 6;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text(`Employee Name: ${employeeName}`, left, y);
  doc.text(`Department: ${departmentName}`, right, y, { align: "right" });
  y += 6;
  doc.setFont("helvetica", "normal");
  const addrLines = doc.splitTextToSize(`Address: ${employeeAddress}`, contentWidth);
  doc.text(addrLines, left, y);
  y += addrLines.length * 5 + 4;

  sections.forEach((section) => {
    ensureSpace(24);
    doc.setDrawColor(228, 233, 240);
    doc.line(left, y, right, y);
    y += 8;
    doc.setFont("times", "bold");
    doc.setFontSize(15);
    doc.text(section.title, left, y);
    y += 7;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);
    section.lines.forEach((line) => {
      const wrapped = doc.splitTextToSize(line, contentWidth);
      ensureSpace(wrapped.length * 5 + 4);
      doc.text(wrapped, left, y);
      y += wrapped.length * 5 + 2;
    });
    y += 4;
  });

  ensureSpace(52);
  doc.setDrawColor(210, 220, 230);
  doc.line(left, y, right, y);
  y += 10;

  const employeeSignatureTop = y;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("Employee Signature", left, employeeSignatureTop);
  if (String(agreement?.signatureDataUrl || "").trim()) {
    try {
      doc.addImage(agreement.signatureDataUrl, "PNG", left, employeeSignatureTop + 4, 52, 18);
    } catch (_err) {
      doc.setFont("helvetica", "normal");
      doc.text(agreement?.signName || employeeName, left, employeeSignatureTop + 14);
    }
  } else {
    doc.setFont("helvetica", "normal");
    doc.text(agreement?.signName || employeeName, left, employeeSignatureTop + 14);
  }
  doc.line(left, employeeSignatureTop + 26, left + 60, employeeSignatureTop + 26);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`Name: ${agreement?.signName || employeeName}`, left, employeeSignatureTop + 32);
  doc.text(`Signed At: ${signedAt}`, left, employeeSignatureTop + 38);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("Authorized Signatory", right - 60, employeeSignatureTop);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(company.authorizedSignatoryName, right - 60, employeeSignatureTop + 14);
  doc.line(right - 60, employeeSignatureTop + 26, right, employeeSignatureTop + 26);
  doc.text(company.authorizedSignatoryRole, right - 60, employeeSignatureTop + 32);
  doc.text(company.name, right - 60, employeeSignatureTop + 38);

  doc.setFontSize(9);
  doc.text(`Generated on ${new Date().toLocaleString("en-IN")}`, left, bottom + 6);
  doc.save(`employee_agreement_${String(employeeName).replace(/[^\w-]+/g, "_") || "employee"}.pdf`);
};
